import { render, staticRenderFns } from "./MonthAllowancesPlanDetailsEdit.vue?vue&type=template&id=635fce7d&scoped=true&"
import script from "./MonthAllowancesPlanDetailsEdit.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanDetailsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fce7d",
  null
  
)

export default component.exports